<ul>
  <li class="map">
    <a uiSref="dimap.project.map" [uiParams]="{ intersectionId: data.item.id }">Zobrazit v mapovém okně</a>
  </li>
</ul>
